// @ts-nocheck
import { Component } from "@theme/component";
import { ThemeEvents, CartAddEvent, SearchPerformedEvent } from "@theme/events";
import {
  triggerPageView,
  triggerTrackEvent,
  triggerTrackClick,
} from "@theme/tealium-utils";

const PROFILE_NAME = "nuanceaudio";

class TealiumComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    //this.initTealium();
    this.createPageViewPayload();
    //this.setGlobalEventListener();

    document.addEventListener(
      ThemeEvents.FilterUpdate,
      this.createEventFilterUpdate.bind(this),
    );
    document.addEventListener(
      ThemeEvents.cartUpdate,
      this.createEventCartAdd.bind(this),
    );
    document.addEventListener(
      ThemeEvents.searchPerformed,
      this.createEventSearchPerformed.bind(this),
    );

    // Usa capture phase per intercettare i click prima che siano bloccati
    document.addEventListener("click", this.handleClickEvent.bind(this), true);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    // Clean up any event listeners or resources if needed
    //document.removeEventListener('click', this.setGlobalEventListener);
    document.removeEventListener(
      ThemeEvents.FilterUpdate,
      this.createEventFilterUpdate.bind(this),
    );
    document.removeEventListener(
      ThemeEvents.cartUpdate,
      this.createEventCartAdd.bind(this),
    );
    document.removeEventListener(
      ThemeEvents.searchPerformed,
      this.createEventSearchPerformed.bind(this),
    );
    document.removeEventListener("click", this.handleClickEvent.bind(this));
  }

  initTealium = (a, b, c, d) => {
    const env = this.dataset.env;

    a = `//tags.tiqcdn.com/utag/luxottica/${PROFILE_NAME}/${env}/utag.js`;
    b = document;
    c = "script";
    d = b.createElement(c);
    d.src = a;
    d.type = "text/java" + c;
    d.async = true;
    a = b.getElementsByTagName(c)[0];
    a.parentNode.insertBefore(d, a);
  };

  // Make it globally accessible

  async createPageViewPayload() {
    let pagetype = this.dataset.pagetype;
    const path = this.dataset.path;
    const templateSuffix = this.dataset.templateSuffix;
    const hasCustomerData = this.dataset.customer != null;
    //treat accessoires as clp
    if (
      pagetype == "collection" &&
      this.dataset.collectionId == this.dataset.accessoriesCollectionId
    ) {
      pagetype = "accessories";
    }

    const tealiumPageType = this.getTealiumPageType(pagetype, templateSuffix);
    let data = {
      Page_Type: tealiumPageType,
      Page_Country: Shopify.country,
      Order_Currency: Shopify.currency.active,
      Page_Section1: this.toPascalCase(this.getPageSection1(tealiumPageType)),
      User_LoginStatus: hasCustomerData ? "Logged" : "Guest",
    };

    if (hasCustomerData) {
      data.User_Id = this.dataset.customerId;
      data.User_Email_MD5 = this.dataset.emailMd5;
      data.User_Email_SHA256 = this.dataset.emailSha256;
      data.User_LoginType = "Standard";
    }
    if (this.pageHasSection2(tealiumPageType)) {
      data.Page_Section2 = this.toPascalCase(
        this.getPageSection2(tealiumPageType),
      );
    }
    if (this.pageHasSection3(tealiumPageType)) {
      //data.Page_Section3 = this.toPascalCase(this.getPageSection3(tealiumPageType));
    }
    if (pagetype === "search") {
      data.Events_SearchRun = "1";
      data.Search_Keyword = this.dataset.terms;
      data.Search_ResultItemsQnt = this.dataset.resultscount;
    }
    if (pagetype === "cart" && this.dataset.cartEmpty === "false") {
      const cartItemsData = await this.getCartItemsDataAnalytics();
      data = { ...data, ...cartItemsData };
    }
    if (pagetype === "product") {
      const productData = await this.getProductDataAnalytics();
      data = { ...data, ...productData };
    }
    if (pagetype === "collection") {
      const productData = await this.getProductsDataAnalytics();
      data = { ...data, ...productData };
    }
    if (pagetype === "404") {
      const errorData = {
        Error_Source: "404",
        Error_Code: "404 - page not found",
        Error_Details: window.location.href,
      };
      data = { ...data, ...errorData };
    }

    triggerPageView(data);
  }

  /* Event not tracked*/
  setGlobalEventListener() {
    document.addEventListener("click", function (event) {
      const target = event.target;
      /*if (target.getAttribute('data-action') === 'newsletter-subscribe') {
                trackNewsletterSignup(target);
            }*/
    });
  }

  getTealiumPageType(shopifyPageType, templateSuffix) {
    const templateSuffixMapping = {
      "store-locator": "StoreLocator",
    };

    if (templateSuffixMapping.hasOwnProperty(templateSuffix)) {
      return templateSuffixMapping[templateSuffix];
    }
    const pageTypeMapping = {
      index: "Home",
      product: "Pdp",
      collection: "Plp",
      accessories: "Clp",
      cart: "CartPage",
      checkout: "Payment",
      search: "Search",
      404: "Error",
      page: "Static",
      blog: "Static",
      article: "Static",
    };
    return pageTypeMapping[shopifyPageType] || "Static";
  }

  getPageSection1(pageType) {
    //for this page use fixed value. For CLP, PDP, PLP, will be first folder in url (TODO)
    const pageSection1Mapping = {
      Home: "Home",
      Landing: "Other",
      Search: "Search",
      CartPage: "CartPage",
      Payment: "Checkout",
      Thankyou: "Checkout",
      Static: "Other",
      Error: "Other",
      StoreLocator: "StoreLocator",
    };

    if (pageSection1Mapping.hasOwnProperty(pageType)) {
      return pageSection1Mapping[pageType] || "Other";
    } else if (pageType === "Plp" || pageType === "Pdp") {
      return this.dataset.title;
    } else {
      // For CLP, PDP, PLP, get the last segment of the URL (excluding query params)
      const pathname = window.location.pathname.split("?")[0]; // Remove query params
      const pathSegments = pathname.split("/").filter(Boolean);
      return pathSegments.length > 0
        ? pathSegments[pathSegments.length - 1]
        : "Other";
    }
  }

  getPageSection2(pageType) {
    let returnValue = null;
    const language = this.dataset.language;
    if (pageType === "Static") {
      //&& language == "en"
      //Put section "Seo title" to get another h1, otherwise first is taken

      const h1 = [...document.querySelectorAll("h1")].find(
        (element) =>
          !element.closest("#section-confirm-access, .section-confirm-access"),
      );
      returnValue = h1 ? h1.textContent.trim() : null;
    } else if (pageType == "Error") {
      returnValue = "ErrorHttp404";
    } else if (pageType === "Pdp") {
      returnValue = this.dataset.modelcode;
    }
    return returnValue;
  }

  pageHasSection2(pageType) {
    const pageWithSection2 = [
      "Landing",
      //'Clp',
      //"Plp",
      "Pdp",
      "Search",
      "Account",
      "Static",
      "Payment",
      "Thankyou",
      "Error",
    ];
    return pageWithSection2.includes(pageType);
  }
  pageHasSection3(pageType) {
    const pageWithSection3 = ["Plp", "Pdp"];
    return pageWithSection3.includes(pageType);
  }

  async getCartItemsDataAnalytics() {
    const response = await fetch("/cart.js");
    const cart = await response.json();

    // Count SKU occurrences to detect duplicates
    const skuCounts = {};
    for (const item of cart.items) {
      const sku = item.sku || `variant_${item.variant_id}`;
      skuCounts[sku] = (skuCounts[sku] || 0) + 1;
    }

    const skuIndex = {};
    const productsObj = {};

    for (const item of cart.items) {
      const baseSku = item.sku || `variant_${item.variant_id}`;
      skuIndex[baseSku] = (skuIndex[baseSku] || 0) + 1;

      const key =
        skuCounts[baseSku] > 1 ? `${baseSku}#${skuIndex[baseSku]}` : baseSku;

      const lens_type =
        item.variant_title?.includes("RX") || item.product_type == "Rox_lens"
          ? "RX"
          : "PLANO";

      productsObj[key] = {
        Status: "Available",
        Price: String((item.final_price / 100).toFixed(2)),
        PriceFull: String((item.original_price / 100).toFixed(2)),
        Units: String(item.quantity),
        LensType: lens_type,
      };
    }
    const result = {
      Products: productsObj,
    };

    if (
      cart.cart_level_discount_applications &&
      cart.cart_level_discount_applications.length > 0
    ) {
      const cartDiscount = cart.cart_level_discount_applications[0];
      result.Order_DiscountName = cartDiscount.title;
      result.Order_DiscountAmount = (
        cartDiscount.total_allocated_amount / 100
      ).toFixed(2);
      result.Order_DiscountAmountNet = (
        cartDiscount.total_allocated_amount / 100
      ).toFixed(2);
    }

    return result;
  }

  async getProductsDataAnalytics() {
    const result = {
      Products: window.collectionProducts,
      Search_ResultItemsQnt: this.dataset.resultsCount,
    };
    if (window.collectionFilters && window.collectionFilters.length > 0) {
      result.Search_FacetValues_String = window.collectionFilters;
    }

    return result;
  }

  //PDP
  async getProductDataAnalytics() {
    const productHandle = this.dataset.productHandle;
    if (!productHandle) return {};

    const response = await fetch(
      window.Shopify.routes.root + `products/${productHandle}.js`,
    );
    const product = await response.json();
    const currentVariant =
      product.variants.find((v) => v.id == this.dataset.currentVariantId) ||
      product.variants[0];

    const sku = currentVariant.sku || `variant_${currentVariant.id}`;
    const price = currentVariant.price;
    const compareAtPrice = currentVariant.compare_at_price || price;
    const lenstype = currentVariant.title.includes("RX") ? "RX" : "PLANO";
    const status = this.getVariantStockStatus(currentVariant);

    const productsObj = {
      [sku]: {
        Status: status,
        Price: String((price / 100).toFixed(2)),
        PriceFull: String((compareAtPrice / 100).toFixed(2)),
        LensType: lenstype,
      },
    };

    const result = { Products: productsObj };

    return result;
  }

  /**
   * Resolves Available/Coming Soon/SoldOut status for a variant by reading the
   * data attributes already rendered on sticky-add-to-cart (metafields aren't
   * available from the products/*.js endpoint).
   */
  getVariantStockStatus(variant) {
    const stickyPanel = document.querySelector("sticky-add-to-cart");

    if (stickyPanel?.dataset.currentVariantId == variant.id) {
      if (
        stickyPanel.dataset.variantAvailable === "true" &&
        stickyPanel.dataset.stock > 0
      )
        return "Available";
      return stickyPanel.dataset.hasEverStock === "true"
        ? "SoldOut"
        : "Coming soon";
    }

    return variant.available ? "Available" : "SoldOut";
  }

  /**
   * @param {FilterUpdateEvent} event
   */
  createEventFilterUpdate(event) {
    // Fired twice per filter change: skip the pre-render dispatch (no resultsCount yet)
    // and only track once the section has re-rendered with the new result set.
    if (event.detail.resultsCount === undefined) return;

    const filterMap = new Map();
    for (const [key, value] of event.detail.queryParams.entries()) {
      if (!key.startsWith("filter.")) continue;
      const label = key.split(".").pop();
      if (!filterMap.has(label)) filterMap.set(label, []);
      if (!value.startsWith("gid://shopify/Metaobject/")) {
        filterMap.get(label).push(this.toPascalCase(value));
      } else {
        const inputLabel = this.getFilterInputLabel(key, value);

        filterMap
          .get(label)
          .push(inputLabel != null ? this.toPascalCase(inputLabel) : value);
      }
    }

    const filterString = [...filterMap.entries()]
      .map(([label, values]) =>
        values.length > 0
          ? values.map((value) => `${label}=${value}`).join("|")
          : label,
      )
      .join("|");

    const data = {
      Events_SearchFiltering: "1",
      Search_FacetValues_String: filterString,
      Search_ResultItemsQnt: String(event.detail.resultsCount),
    };
    triggerTrackEvent(data);
  }

  /**
   * Finds the human-readable label for a filter input, read from the
   * aria-label (swatches/images) or data-label (pills/checkboxes) attribute.
   * @param {string} name - The input's name attribute (filter param name)
   * @param {string} value - The input's value attribute
   * @returns {string|null}
   */
  getFilterInputLabel(name, value) {
    const input = document.querySelector(
      `input[name="${CSS.escape(name)}"][value="${CSS.escape(value)}"]`,
    );
    return input?.getAttribute("aria-label") || input?.dataset.label || null;
  }

  /**
   * @param {CartAddEvent} event
   */
  createEventCartAdd(event) {
    const item = event.detail.data?.addedItem;
    if (!item) return;

    const sku = item.sku || `variant_${event.detail.sourceId}`;
    const compareAtPrice = item.compare_at_price || item.price;
    const lensType = item.variantTitle.includes("RX") ? "RX" : "PLANO";

    const data = {
      Events_CartAdd: "1",
      Products: {
        [sku]: {
          Status: "Available",
          Price: String((item.price / 100).toFixed(2)),
          PriceFull: String((compareAtPrice / 100).toFixed(2)),
          Units: String(item.quantity),
          LensType: lensType,
        },
      },
    };
    triggerTrackEvent(data);
  }

  /**
   * @param {SearchPerformedEvent} event
   */
  createEventSearchPerformed(event) {
    const searchTerm = event.detail.keyword;
    const data = {
      Events_SearchRun: "1",
      Search_Keyword: searchTerm,
    };
    triggerTrackEvent(data);
  }

  toPascalCase(str) {
    if (!str) return str;
    return str
      .replace(/-/g, " ") // Converti trattini in spazi
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word) {
        return word.toUpperCase();
      })
      .replace(/\s+/g, "");
  }

  toPascalCaseWithUnderscore(str, maxLength = 25) {
    if (!str) return str;
    return str
      .split("_")
      .map((part) => {
        // Rimuovi caratteri speciali (mantieni solo alfanumerici)
        const cleaned = part.replace(/[^a-zA-Z0-9]/g, " ");
        return this.toPascalCase(cleaned);
      })
      .join("_")
      .slice(0, maxLength);
  }

  handleClickEvent(event) {
    if (!(event.target instanceof Element)) return;

    const closestUntilAnalyticsBoundary = (
      start,
      matchSelector,
      stopSelector,
    ) => {
      let current = start;
      while (current) {
        if (current.matches(stopSelector)) return null;
        if (current.matches(matchSelector)) return current;
        current = current.parentElement;
      }
      return null;
    };

    const target = closestUntilAnalyticsBoundary(
      event.target,
      "[data-element-id]",
      "[data-analytics-available-call]",
    );
    //console.log("target", target);
    if (!target) return;
    /*
    if (target.getAttribute("aria-expanded") === "true") {
      // If the element is expanded, we don't want to track the click yet.
      return;
    }*/
    const data = {
      data_element_id: this.toPascalCaseWithUnderscore(
        target.getAttribute("data-element-id"),
      ),
    };
    if (target.hasAttribute("data-description")) {
      data.data_description = this.toPascalCaseWithUnderscore(
        target.getAttribute("data-description"),
        25,
      );
    }
    //use hiddenaction when redirect to another page
    if (target.hasAttribute("data-redirect")) {
      data.Tracking_Type = target.getAttribute("data-redirect");
    }

    if (target.hasAttribute("data-analytics-available-call")) {
      data.data_analytics_available_call = target.getAttribute(
        "data-analytics-available-call",
      );
    }
    triggerTrackClick(data);
  }
}

if (!customElements.get("tealium-component")) {
  customElements.define("tealium-component", TealiumComponent);
}
